module.exports = __webpack_public_path__ + "img/bopp_tape.a9d7d6e5.png";